import React from 'react';

const MobileNavbarContext = React.createContext();

export default MobileNavbarContext;
